import { ManipulateType } from "dayjs";
import { TFunction } from "i18next";

// DO NOT TRANSLATE, for database use only
export enum Duration {
  Second = "s",
  Minute = "m",
  Hour = "H",
  Day = "D",
  Week = "W",
  Month = "M",
  Year = "Y",
}

export type TimeDuration = {
  num: number;
  duration: Duration;
};

// DO NOT TRANSLATE
export const durationToDayjs = (
  range: Duration
): ManipulateType | undefined => {
  switch (range) {
    case Duration.Second:
      return "second";
    case Duration.Minute:
      return "minute";
    case Duration.Hour:
      return "hour";
    case Duration.Day:
      return "day";
    case Duration.Week:
      return "week";
    case Duration.Month:
      return "month";
    case Duration.Year:
      return "year";
  }
};

export function durationToDisplay(
  range: Duration,
  t: TFunction<"translation">
): string | undefined {
  switch (range) {
    case Duration.Second:
      return t("second");
    case Duration.Minute:
      return t("minute");
    case Duration.Hour:
      return t("hour");
    case Duration.Day:
      return t("day");
    case Duration.Week:
      return t("week");
    case Duration.Month:
      return t("month");
    case Duration.Year:
      return t("year");
  }
}

export const parseTimeDuration = (value: string): TimeDuration | undefined => {
  const split = value.split(" ");
  if (split.length !== 2) return;
  const num = Number(split[0]);
  const duration = split[1] as Duration;
  return {
    num,
    duration,
  };
};

export const convertDuration = (duration: Duration, time?: TimeDuration) => {
  if (!time) return undefined;
  switch (time.duration) {
    case Duration.Second:
      switch (duration) {
        case Duration.Second:
          return time.num;
        case Duration.Minute:
          return time.num / 60;
        case Duration.Hour:
          return time.num / (60 * 60);
        case Duration.Day:
          return time.num / (60 * 60 * 24);
        case Duration.Week:
          return time.num / (60 * 60 * 24 * 7);
        case Duration.Month:
          return time.num / (60 * 60 * 24 * 28);
        case Duration.Year:
          return time.num / (60 * 60 * 24 * 365);
      }
      break;
    case Duration.Minute:
      switch (duration) {
        case Duration.Second:
          return time.num * 60;
        case Duration.Minute:
          return time.num;
        case Duration.Hour:
          return time.num / 60;
        case Duration.Day:
          return time.num / (60 * 24);
        case Duration.Week:
          return time.num / (60 * 24 * 7);
        case Duration.Month:
          return time.num / (60 * 24 * 28);
        case Duration.Year:
          return time.num / (60 * 24 * 365);
      }
      break;
    case Duration.Hour:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60;
        case Duration.Minute:
          return time.num * 60;
        case Duration.Hour:
          return time.num;
        case Duration.Day:
          return time.num / 24;
        case Duration.Week:
          return time.num / (24 * 7);
        case Duration.Month:
          return time.num / (24 * 28);
        case Duration.Year:
          return time.num / (24 * 365);
      }
      break;
    case Duration.Day:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24;
        case Duration.Minute:
          return time.num * 60 * 24;
        case Duration.Hour:
          return time.num * 24;
        case Duration.Day:
          return time.num;
        case Duration.Week:
          return time.num / 7;
        case Duration.Month:
          return time.num / 28;
        case Duration.Year:
          return time.num / 365;
      }
      break;
    case Duration.Week:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 7;
        case Duration.Minute:
          return time.num * 60 * 24 * 7;
        case Duration.Hour:
          return time.num * 24 * 7;
        case Duration.Day:
          return time.num * 7;
        case Duration.Week:
          return time.num;
        case Duration.Month:
          return time.num / 4;
        case Duration.Year:
          return time.num / 52;
      }
      break;
    case Duration.Month:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 28;
        case Duration.Minute:
          return time.num * 60 * 24 * 28;
        case Duration.Hour:
          return time.num * 24 * 28;
        case Duration.Day:
          return time.num * 28;
        case Duration.Week:
          return time.num * 4;
        case Duration.Month:
          return time.num;
        case Duration.Year:
          return time.num / 12;
      }
      break;
    case Duration.Year:
      switch (duration) {
        case Duration.Second:
          return time.num * 60 * 60 * 24 * 365;
        case Duration.Minute:
          return time.num * 60 * 24 * 365;
        case Duration.Hour:
          return time.num * 24 * 365;
        case Duration.Day:
          return time.num * 365;
        case Duration.Week:
          return time.num * 52;
        case Duration.Month:
          return time.num * 12;
        case Duration.Year:
          return time.num;
      }
  }
};
